export enum COOKIE_KEY {
  COMPARISON_PROMO = 'comparison_promotion_shown',
  COOKIE_CONSENT_MANAGER = 'oil_GTM_cookie',
  // EMPLOYEE_MODE = 'employee_mode',
  GCL_AW = '_gcl_aw',
  LIST_VIEW_DESKTOP = 'list_view_desktop_preference',
  LIST_VIEW_DESKTOP_ABTEST = 'lv_d_p_ab_2', // list view desktop preference abtest
  LIST_VIEW_DESKTOP_EVOLUTION = 'list_view_desktop_evolution_preference', // isolated cookie for evolution mode
  // LIST_VIEW_MOBILE = 'list_view_mobile_preference', // mobile cookie is deprecated
  CSRF_NONCE = '__csrf_nonce',
  MPT = '__mpt',
  // MPH-1154: TSX's own httpOnly copy of the enriched Casper token, the one carrying the account id.
  TSX_MPT = '__tsx_mpt',
  // MPH-1154: set for a minute after asking Casper for that token failed, so the tab stops waiting on it.
  TSX_MPT_BACKOFF = '__tsx_mpt_backoff',
  MYPRICE_POPUP_SHOWN = 'MP_P_S',
  OVERNIGHT_FLIGHTS_POPUP = 'overnight_flights_popup_shown',
  TAXES_INCLUDED_V3_POPUP = 'taxes_included_v3_popup_shown',
  TOTAL_PRICE_EVOLUTION = 'tp_e_p_1', // total price evolution preference — isolated cookie for evolution mode
  TSX_INVALID_URL = 'temp_tsx_invalid_url',
  APP_ID = 'tsxid',
  FILTER_SESSION = 'f_act',
}

export type TotalPricePreference = 'total' | 'pp';

export const COOKIE_APP_ID = 'xst';
